import { Component, DestroyRef, OnInit } from '@angular/core';
import { API, MarkerDTO } from 'src/app/services/api/api';
import { ErrorService } from 'src/app/services/error.service';
import { ModalNavigationComponent } from 'src/app/services/gui/modal/modal-navigation-component';
import { ModalNavigationService } from 'src/app/services/gui/modal/modal-navigation.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { take } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'sb-bookable-markers',
  templateUrl: './sb-bookable-markers.component.html',
  styleUrls: ['./sb-bookable-markers.component.scss'],
  standalone: false,
})
export class SbBookableMarkersComponent implements OnInit, ModalNavigationComponent {
  debounceTimer: ReturnType<typeof setTimeout> = null;

  constructor(
    private api: API,
    private modalNavigation: ModalNavigationService,
    public errorHandler: ErrorService,
    private destroyRef: DestroyRef
  ) {}

  isInModalContext: boolean;

  data: MarkerDTO[] = [];

  loading: boolean;

  ngOnInit(): void {
    this.refreshFromServer();
  }

  select(marker: MarkerDTO) {
    if (this.isInModalContext) {
      this.modalNavigation.result(marker);
    }
  }

  requestDebounced() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      this.refreshFromServer();
    }, 500);
  }

  refreshFromServer() {
    this.loading = true;
    this.api
      .ss_nm_Channel_getBookableMarkers()
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        take(1),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe({
        next: (result: MarkerDTO[]) => {
          this.data = result;
        },
        error: err => {
          this.errorHandler.errorHandler(err);
        },
      });
  }
}
